import React from 'react';

import { useHasPermission } from '@vlabs/permissions';
import { generatePath, useHistory } from 'react-router-dom';

import { routes } from '../../../app/routes';
import { DeleteListsButton } from '../../list-list-page/buttons/DeleteListsButton';
import { ListGeneralInfo } from '../list-general-info';
import { useListIdFromLocation } from '../useListIdFromLocation';
import { ListDetailsPageHeader } from './list-details-page-header';
import { ListCardsViewer } from './list-details-viewer';
import st from './ListDetailsPageContent.module.sass';

export function ListDetailsPageContent(): React.JSX.Element {
  const listId = useListIdFromLocation();
  const history = useHistory();
  const canDeleteList = useHasPermission('list', 'delete');

  return (
    <React.Fragment>
      <ListDetailsPageHeader listId={listId} />
      <div className={st.Main}>
        <div className={st.Sidebar}>
          <div className={st.InfoWrapper}>
            <ListGeneralInfo listId={listId} />
          </div>
          <div className={st.ActionWrapper}>
            {!!canDeleteList && (
              <DeleteListsButton
                listIds={[listId]}
                onDeleteLists={() => history.push(generatePath(routes.cardsAndLists.activeTab, { activeTab: 'lists' }))}
              />
            )}
          </div>
        </div>
        <ListCardsViewer listId={listId} />
      </div>
    </React.Fragment>
  );
}
